/* DSL CDN warm-up — prefetch alle images on collection page tijdens idle */
(function(){
  if (!window.requestIdleCallback) return;
  if (location.pathname.indexOf("/collections/") !== 0) return;
  requestIdleCallback(function(){
    document.querySelectorAll("img[src*=\"cdn.shopify.com\"], img[src*=\"cdn/shop/files\"]").forEach(function(img){
      if (img.dataset.warmed) return;
      img.dataset.warmed = "1";
      // Use <link rel=prefetch> for unrendered srcset variants
      var srcset = img.srcset || "";
      var urls = srcset.split(",").map(function(s){return s.trim().split(" ")[0];}).filter(Boolean);
      urls.slice(0, 3).forEach(function(u){
        var l = document.createElement("link"); l.rel = "prefetch"; l.as = "image"; l.href = u; document.head.appendChild(l);
      });
    });
  }, {timeout: 5000});
})();